import { createContext, useContext } from 'react';

export interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  name: string | null;
  email: string | null;
  roles: string[];
  login: (loginHint?: string) => Promise<void>;
  logout: () => void;
  getAccessToken: () => Promise<string>;
  refreshAuth: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
